import React from "react";
import { motion } from "framer-motion";

const Section = ({ title, items }) => (
    <motion.section
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: "easeInOut" }}
        className="shadow-lg border rounded-xl p-6 bg-alphaGreen-50 dark:bg-alphaOrange-900/20 border-dashed border-alphaGreen-500 dark:border-alphaOrange-500 smooth"
    >
        <h2 className="text-3xl font-semibold text-alphaGreen-700 dark:text-alphaAccentText mb-6 border-b pb-2 border-alphaGreen-200 dark:border-alphaOrange-400 smooth">
            {title}
        </h2>
        <ul className="list-disc space-y-4 pl-6">
            {items.map((item, index) => (
                <li key={index} className="text-gray-500 dark:text-gray-300 smooth">
                    <strong className="text-black dark:text-alphaAccentText smooth">
                        {item.label}:
                    </strong>{" "}
                    {item.content}
                </li>
            ))}
        </ul>
    </motion.section>
);
const BackgroundAnimation = () => (
    <div className="absolute inset-0 overflow-hidden -z-10">
        <motion.div
            className="w-64 h-64 bg-alphaGreen-200 dark:bg-alphaOrange-500 rounded-full opacity-30 blur-2xl"
            animate={{ x: [0, 200, 0], y: [0, -100, 0] }}
            transition={{ duration: 10, repeat: Infinity, ease: "easeInOut" }}
        />
        <motion.div
            className="w-96 h-96 bg-alphaOrange-300 dark:bg-alphaGreen-600 rounded-full opacity-20 blur-3xl absolute top-10 left-20"
            animate={{ x: [0, -200, 0], y: [0, 150, 0] }}
            transition={{ duration: 12, repeat: Infinity, ease: "easeInOut" }}
        />
        <motion.div
            className="w-72 h-72 bg-alphaGreen-300 dark:bg-alphaOrange-700 rounded-full bg-opacity-20 blur-2xl absolute bottom-10 right-10"
            animate={{ x: [0, 150, 0], y: [0, -150, 0] }}
            transition={{ duration: 14, repeat: Infinity, ease: "easeInOut" }}
        />
    </div>
);
const TermsAndPolicy = () => {
    const studentPolicies = [
        {
            label: "الاحترام المتبادل",
            content:
                "يجب أن يتعامل الطلاب مع المدرسين وزملائهم بأدب واحترام. يمنع استخدام اللغة المسيئة أو التصرفات العدوانية.",
        },
        {
            label: "المشاركة الفعالة",
            content:
                "الالتزام بحضور الجلسات التعليمية والتفاعل مع المحتوى. تقديم الأسئلة والاستفسارات بشكل بنّاء لتحسين تجربة التعلم.",
        },
        {
            label: "الحفاظ على الخصوصية",
            content:
                "يمنع مشاركة الحسابات أو بيانات التسجيل مع الآخرين. لا يُسمح بتسجيل الدروس أو مشاركتها دون إذن كتابي من الإدارة.",
        },
        {
            label: "استخدام المواد التعليمية",
            content:
                "يجب استخدام المواد التعليمية لأغراض شخصية فقط وعدم توزيعها أو استغلالها تجاريًا.",
        },
        {
            label: "التقيد بالمواعيد",
            content:
                "الالتزام بالمواعيد المحددة للدروس والواجبات. إعلام المدرس مسبقًا في حال عدم القدرة على الحضور.",
        },
    ];

    const teacherPolicies = [
        {
            label: "الاحترافية",
            content:
                "تقديم الدروس بجودة عالية وبأسلوب مهني. الالتزام بالمواعيد والجداول الزمنية المحددة.",
        },
        {
            label: "التواصل الفعّال",
            content:
                "استخدام لغة واضحة ومفهومة خلال الدروس. الرد على استفسارات الطلاب بشكل مهني وفي الوقت المناسب.",
        },
        {
            label: "حماية الخصوصية",
            content: "عدم مشاركة بيانات الطلاب أو استخدام محتواهم الشخصي دون إذن.",
        },
        {
            label: "إدارة المحتوى",
            content: "تحديث المواد التعليمية بانتظام لتلبية احتياجات الطلاب.",
        },
        {
            label: "التعامل العادل",
            content:
                "تقديم الدعم لجميع الطلاب دون تمييز. احترام اختلاف مستويات الطلاب ومساعدتهم على تحقيق أهدافهم.",
        },
    ];

    const generalPolicies = [
        {
            label: "استخدام المنصة",
            content: "يمنع استخدام المنصة لأي أنشطة غير قانونية أو تخالف القوانين المحلية.",
        },
        {
            label: "الدعم الفني",
            content:
                "تتوفر خدمات الدعم الفني للطلاب والمدرسين لحل المشكلات التقنية. يُرجى استخدام قنوات الدعم الرسمية فقط للحصول على المساعدة.",
        },
        {
            label: "سياسة الإلغاء والاسترداد",
            content:
                "يُرجى مراجعة شروط الإلغاء والاسترداد الموجودة على الموقع للحصول على التفاصيل.",
        },
        {
            label: "التحديثات",
            content:
                "يحتفظ فريق المنصة بالحق في تعديل السياسات حسب الحاجة. سيتم إشعار المستخدمين بأي تغييرات عبر البريد الإلكتروني أو إشعارات المنصة.",
        },
        {
            label: "عواقب عدم الالتزام بالسياسات",
            content:
                "في حالة خرق السياسات، سيتم إصدار تحذير رسمي. في حالة التكرار، يتم فرض حظر مؤقت يحدده المسؤول لمدة مناسبة. إذا تكرر الخطأ ثلاث مرات، يتم فرض حظر دائم على الحساب.",
        },
    ];

    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8, ease: "easeInOut" }}
            className="relative negative-nav-margin py-[10rem] min-h-screen  px-6 sm:px-12 font-ibm-arabic lg:px-24"
        >
            <BackgroundAnimation />

            <div className="max-w-7xl mx-auto">
                <motion.h1
                    initial={{ opacity: 0, y: -20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6, ease: "easeInOut" }}
                    className="text-4xl smooth font-extrabold text-center text-alphaGreen-700 dark:text-alphaAccentText mb-12"
                >
                    سياسات الاستخدام وتعليمات يجب اتباعها
                </motion.h1>{" "}
                <div className="space-y-12 text-gray-800 dark:text-gray-200">
                    <Section title="للطالب" items={studentPolicies} />
                    <Section title="للمدرس" items={teacherPolicies} />
                    <Section title="سياسات عامة" items={generalPolicies} />
                    <motion.p
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6, ease: "easeInOut" }}
                        className="text-center text-xl smooth font-medium mt-12"
                    >
                        باتباع هذه السياسات والتعليمات، نضمن تجربة تعليمية متميزة ومحترمة لجميع
                        الأطراف على منصة ألفا.
                    </motion.p>
                </div>
            </div>
        </motion.div>
    );
};

export default TermsAndPolicy;
